import { motion } from "framer-motion";
import React from "react";
import { homeAni } from "./animation";
import MailComp from "./MailComp";
import { SocialLinks } from "./SocialLinks";
import { TopNav } from "./TopNav";

function ContactPageComp({ props }) {
  return (
    <>
      <div className="contact--page--wrapper">
        <main className="contact--main">
          <TopNav path={props.location.pathname} />
          <div className="contact--content">
            <div className="contact--top">
              <motion.h1
                variants={homeAni}
                initial="initial"
                animate="animate"
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { delay: 0.5, duration: 0.6 },
                }}
                transition={{ duration: 0.8 }}
              >
                Let's talk business
              </motion.h1>
              <motion.p
                variants={homeAni}
                initial="initial"
                animate="animate"
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { delay: 0.4, duration: 0.6 },
                }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                Need a website, or blog or design, just mail your requirements, I
                will make you a proposal
              </motion.p>
              <MailComp
                transition={{ duration: 0.8, delay: 0.3 }}
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { duration: 0.7, delay: 0.3 },
                }}
              />
            </div>
            <SocialLinks />
          </div>
        </main>
      </div>
    </>
  );
}

export { ContactPageComp };
